export default {
  path: "/user/cpa/rifas",
  component: () => import("@/views/user/cpa/rifas/RifasLayout.vue"),
  meta: {
    requiresAuth: true,
    requiresCurso: true,
    requiresCpaDirectiva: true,
  },
  children: [
    {
      path: "",
      name: "rifas-dashboard",
      component: () => import("@/views/user/cpa/rifas/RifasDashboard.vue"),
    },
    {
      path: "nueva",
      name: "rifas-nueva",
      component: () => import("@/views/user/cpa/rifas/RifaEditorView.vue"),
    },
    {
      path: ":raffleId/editar",
      name: "rifas-editar",
      component: () => import("@/views/user/cpa/rifas/RifaEditorView.vue"),
      props: true,
    },
    {
      path: ":raffleId",
      name: "rifas-detalle",
      component: () => import("@/views/user/cpa/rifas/RifaDetalleView.vue"),
      props: true,
    },
  ],
};

export const publicRifasRoutes = [
  {
    path: "/rifas/vendedor/:token",
    name: "rifas-vendedor",
    component: () => import("@/views/public/RaffleSellerView.vue"),
    props: true,
    meta: { public: true },
  },
  {
    path: "/rifas/verificar/:token",
    name: "rifas-verificar",
    component: () => import("@/views/public/RaffleVerifyView.vue"),
    props: true,
    meta: { public: true },
  },
];
